import { ObstacleType } from "../Data/Obstacles";
import { Boomerang } from "../GameObjects/Obstacles/Boomerang";
import { Dinosaur } from "../GameObjects/Obstacles/Dinosaur";
import { DyeBomb } from "../GameObjects/Obstacles/DyeBomb";
import { Fuujin } from "../GameObjects/Obstacles/Fuujin";
import { FuujinProjectile } from "../GameObjects/Obstacles/FuujinProjectile";
import { LanternGroup } from "../GameObjects/Obstacles/LanternGroup";
import { Obstacle } from "../GameObjects/Obstacles/Obstacle";
import { Paletas } from "../GameObjects/Obstacles/Paletas";
import { PaletasProjectile } from "../GameObjects/Obstacles/PaletasProjectile";
import { Parrot } from "../GameObjects/Obstacles/Parrot";
import { Pigeon } from "../GameObjects/Obstacles/Pigeon";
import { Scarab } from "../GameObjects/Obstacles/Scarab";
import { Sputnik } from "../GameObjects/Obstacles/Sputnik";
import { WorldElement } from "../GameObjects/WorldElement";
import { ObjectPool } from "../Utils/ObjectPool";

export class ElementFactory {
    private static _instance: ElementFactory;

    private _elementPool: ObjectPool<WorldElement>;

    private constructor() {
        this._elementPool = new ObjectPool<WorldElement>(() => new WorldElement());
    }

    public static get instance(): ElementFactory {
        if (this._instance === undefined) {
            this._instance = new ElementFactory();
        }
        return this._instance;
    }

    public getElement(): WorldElement {
        return this._elementPool.getObject();
    }

    public makeObstacle(pObstacle: ObstacleType): Obstacle {
        let obstacle: Obstacle;
        switch (pObstacle) {
            case ObstacleType.BOOMERANG:
                obstacle = new Boomerang();
                break;
            case ObstacleType.DINOSAUR:
                obstacle = new Dinosaur();
                break;
            case ObstacleType.DYE:
                obstacle = new DyeBomb();
                break;
            case ObstacleType.FUUJIN:
                obstacle = new Fuujin();
                break;
            case ObstacleType.FUUJIN_PROJECTILE:
                obstacle = new FuujinProjectile();
                break;
            case ObstacleType.LANTERN:
                obstacle = new LanternGroup();
                break;
            case ObstacleType.PALETAS:
                obstacle = new Paletas();
                break;
            case ObstacleType.PALETAS_PROJECTILE:
                obstacle = new PaletasProjectile();
                break;
            case ObstacleType.PARROT:
                obstacle = new Parrot();
                break;
            case ObstacleType.PIGEON:
                obstacle = new Pigeon();
                break;
            case ObstacleType.SCARAB:
                obstacle = new Scarab();
                break;
            case ObstacleType.SPUTNIK:
                obstacle = new Sputnik();
                break;
        }
        return obstacle!;
    }

    public returnElement(pElement: WorldElement): void {
        if (pElement instanceof Obstacle) {
            return;
        }
    }
}
